import { init } from 'init';

try {
    init();
} catch (e) {
    throw Error('Favs-agent: Can´t render AgentModal');
}
